import React from "react";
import { DatePicker, defaultDatePickerStrings } from "@fluentui/react";
import { Editor } from "react-draft-wysiwyg";
import {
  Flex,
  Button,
  Text,
  Checkbox,
  Tooltip,
  Input,
} from "@fluentui/react-northstar";
import { TextField } from "@fluentui/react/lib/TextField";
import { Dropdown } from "@fluentui/react/lib/Dropdown";
import moment from "moment";
import AttachmentOption from "../AttachmentOption/AttachmentOption";
import { gptIcon } from "../../../../Assets/icons/icons";

const AssignmentForm = ({
  assignmentTitle,
  setAssignmentTitle,
  setCurrentAssignmentData,
  assignmentDetailsTranslation,
  errorCheckobj,
  instruction,
  onEditorStateChange,
  handlePastedText,
  uploadImageCallBack,
  attachmentList,
  setAttachmentList,
  user,
  setSelectedAvatarVideo,
  selectedAvatarVideo,
  setState,
  state,
  settings,
  selectedExtension,
  selectedStudentForSubmission = [],
  onStudentForSubmissionSelectChange,
  currentLessionStudentList,
  dueDate,
  setDueDate,
  selectedLesson,
  markingType,
  setMarkingType,
  isCreateUpdateAssignmentLoading,
  props,
  setDeleteAssignmentConfirm,
  setConfirmUpdateChanges,
  isMobileView,
  isTabletView,
  currentAssignmentData,
  setSelectedTab,
  setCreateAssignmentDlg,
  toggleFilter,
}) => (
  <div
    className="ms-Grid"
    style={{
      padding: isMobileView || isTabletView ? "15px 15px 0px 15px" : "0 8px",
    }}
  >
    <div className="ms-Grid-row" style={{ marginBottom: "10px" }}>
      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl8">
            <div className="tour-create-assignment-title-instruction">
              <div style={{ marginBottom: 16 }}>
                <Text
                  weight="semibold"
                  style={{ display: "block", marginBottom: 4 }}
                >
                  {assignmentDetailsTranslation.assignmentTitle}
                  <span style={{ color: "#a4262c", marginLeft: 2 }}>*</span>
                </Text>
                <Flex
                  gap="gap.smaller"
                  vAlign="center"
                  style={{ width: "100%" }}
                >
                  <Input
                    fluid
                    value={assignmentTitle}
                    onChange={(e, { value }) => {
                      setAssignmentTitle(value);
                      setCurrentAssignmentData((prevData) => ({
                        ...prevData,
                        assignmentTitle: value,
                        isChanged: true,
                      }));
                    }}
                    input={{
                      "data-cy": "assignment-title",
                      style: {
                        background: "#F5F5F5",
                        borderRadius: 5,
                        flexGrow: 1,
                        minWidth: 0,
                        border: "none",
                      },
                      required: true,
                    }}
                  />
                  <Tooltip
                    content={"Generate assignment content with AI"}
                    trigger={
                      <Button
                        data-cy="magicbar-btn"
                        icon={gptIcon()}
                        text
                        iconOnly
                        onClick={() =>
                          setCreateAssignmentDlg((prev) => ({
                            ...prev,
                            open: true,
                          }))
                        }
                      />
                    }
                  />
                </Flex>
                {errorCheckobj.title && !assignmentTitle?.length && (
                  <Text
                    style={{
                      color: "#d13438",
                      fontSize: 13,
                      marginTop: 4,
                      display: "block",
                    }}
                  >
                    {assignmentDetailsTranslation.assignmentTitleValidation}
                  </Text>
                )}
              </div>
              <div>
                <div className="mt-3 mb-2">
                  <Text className="text-field-padding" weight="semibold">
                    {assignmentDetailsTranslation.instructions}
                  </Text>
                </div>
                <div className="draft-editor">
                  <Editor
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editorClassName"
                    editorState={instruction}
                    onEditorStateChange={onEditorStateChange}
                    handlePastedText={handlePastedText}
                    wrapperStyle={{ borderRadius: "5px" }}
                    toolbarStyle={{ borderRadius: "5px" }}
                    editorStyle={{ minHeight: "100px" }}
                    toolbar={{
                      inline: {
                        options: ["bold", "italic", "underline"],
                      },
                      list: {
                        options: ["unordered", "ordered"],
                      },
                      textAlign: {},
                      link: {},
                      image: {
                        uploadCallback: uploadImageCallBack,
                        urlEnabled: true,
                        uploadEnabled: true,
                        alignmentEnabled: true,
                        previewImage: true,
                        inputAccept:
                          "image/gif,image/jpeg,image/jpg,image/png,image/svg",
                        alt: { present: false, mandatory: false },
                        defaultSize: {
                          height: "auto",
                          width: "auto",
                        },
                      },
                      emoji: {},
                      options: [
                        "inline",
                        "list",
                        "textAlign",
                        "link",
                        "image",
                        "emoji",
                      ],
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="tour-create-assignment-attachments">
              <div className="mt-3">
                <Text weight="semibold">
                  {assignmentDetailsTranslation.addAttachment}
                </Text>
              </div>
              <div>
                <AttachmentOption
                  attachmentList={attachmentList}
                  setAttachmentList={setAttachmentList}
                  user={user}
                  setSelectedAvatarVideo={setSelectedAvatarVideo}
                  selectedAvatarVideo={selectedAvatarVideo}
                  setState={setState}
                  state={state}
                  settings={settings}
                  selectedExtension={selectedExtension}
                />
              </div>
            </div>
          </div>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl4">
            <div className="tour-create-assignment-students-duedate-grade">
              <Dropdown
                placeholder={
                  assignmentDetailsTranslation.assignmentForPlaceholder
                }
                data-cy="assignment-for"
                label={assignmentDetailsTranslation.assignmentFor}
                selectedKeys={selectedStudentForSubmission}
                onChange={onStudentForSubmissionSelectChange}
                multiSelect
                options={currentLessionStudentList}
                errorMessage={
                  errorCheckobj.assignmentFor
                    ? Array.isArray(selectedStudentForSubmission) &&
                      selectedStudentForSubmission.length
                      ? ""
                      : assignmentDetailsTranslation.assignmentForValidation
                    : ""
                }
                required
              />
              <div className="mt-3">
                <DatePicker
                  value={dueDate}
                  onSelectDate={(value) => {
                    setDueDate(value);
                    setCurrentAssignmentData((prevData) => ({
                      ...prevData,
                      dueDate: value,
                      isChanged: true,
                    }));
                  }}

                  label={
                    <Text>
                      {assignmentDetailsTranslation.dueDate}{" "}
                      {!errorCheckobj.dueDate ? (
                        <Text style={{ color: "#a4262c" }}>*</Text>
                      ) : null}
                    </Text>
                  }
                  ariaLabel={assignmentDetailsTranslation.dueDatePlaceholder}
                  strings={{
                    ...defaultDatePickerStrings,
                    isOutOfBoundsErrorMessage:
                      assignmentDetailsTranslation.dueDateValidation,
                  }}
                  placeholder={assignmentDetailsTranslation.dueDatePlaceholder}
                  minDate={
                    new Date(
                      moment
                        .utc(selectedLesson?.LessonDate)
                        .local()
                        .format("MM-DD-YYYY")
                    )
                  }
                  isRequired={errorCheckobj.dueDate}
                />
              </div>

              <div className="mt-3">
                <TextField
                  value={markingType}
                  data-cy="assign-grades"
                  onChange={(e, value) => {
                    let marking = value >= 0 ? value : 0;
                    setMarkingType(marking);
                    setCurrentAssignmentData((prevData) => ({
                      ...prevData,
                      markingType: marking,
                      isChanged: true,
                    }));
                  }}
                  style={{ background: "#F5F5F5", borderRadius: "5px" }}
                  borderless={true}
                  label={assignmentDetailsTranslation.grade}
                  placeholder={assignmentDetailsTranslation.gradePlaceholder}
                  type="number"
                />
              </div>
            </div>

            <div className="mt-4">
              <Flex
                wrap
                gap="gap.medium"
                className="assignment-action-button-wrapper"
              >
                <Flex.Item>
                  <Button
                    data-cy="assign-rubric-btn"
                    content={
                      props.data?.rubric?.rubricItems?.length ||
                        currentAssignmentData?.rubric?.rubricItems?.length
                        ? assignmentDetailsTranslation.viewRubric
                        : assignmentDetailsTranslation.createRubric
                    }
                    className="tour-create-assignment-rubric"
                    onClick={() => {
                      // props.setState({ isCreatingRubric: true });
                      setSelectedTab("rubrics");
                      toggleFilter("close");
                    }}
                  />
                </Flex.Item>

                <Flex.Item>
                  {props.data ||
                    (!currentAssignmentData?.isNew &&
                      (currentAssignmentData?.status == "Published" ||
                        currentAssignmentData?.status == "save" ||
                        currentAssignmentData?.status == "Publish Later")) ? (
                    <Button
                      data-cy="delete-assignment-btn"
                      className={`delete-btn-bg ${isCreateUpdateAssignmentLoading ? "disabled" : ""
                        }`}
                      content={assignmentDetailsTranslation.deleteAssignment}
                      onClick={() => {
                        setDeleteAssignmentConfirm(true);
                      }}
                      disabled={isCreateUpdateAssignmentLoading}
                    />
                  ) : null}
                </Flex.Item>
                {currentAssignmentData?.status === "Published" ? (
                  <Flex.Item>
                    <Button
                      data-cy="update-assign-btn"
                      content={assignmentDetailsTranslation.updateChanges}
                      onClick={() => {
                        setConfirmUpdateChanges(true);
                      }}
                      disabled={
                        !currentAssignmentData.isChanged ||
                        isCreateUpdateAssignmentLoading
                      }
                    />
                  </Flex.Item>
                ) : null}
              </Flex>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AssignmentForm;
